import { render, staticRenderFns } from "./EditableSlot.vue?vue&type=template&id=6637a374&"
import script from "./EditableSlot.vue?vue&type=script&lang=ts&"
export * from "./EditableSlot.vue?vue&type=script&lang=ts&"
import style0 from "./EditableSlot.vue?vue&type=style&index=0&id=6637a374&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports